import { AbortError as e } from "../../errors/abort-error.mjs";
import { AccessDenied as t } from "../../errors/access-denied.mjs";
import { BadRequest as n } from "../../errors/bad-request.mjs";
import { ConflictError as r } from "../../errors/conflict-error.mjs";
import { FailedDependency as i } from "../../errors/failed-dependency.mjs";
import { InternalError as a } from "../../errors/internal-error.mjs";
import { LockedError as o } from "../../errors/locked-error.mjs";
import { MaintenanceError as s } from "../../errors/maintenance-error.mjs";
import { NotFound as c } from "../../errors/not-found.mjs";
import { PayloadTooLarge as l } from "../../errors/payload-too-large.mjs";
import { UnauthorizedResponse as u } from "../../errors/unauthorized-response.mjs";
import { UnprocessableContentError as d } from "../../errors/unprocessable-content-error.mjs";
import { checkAreThereFieldsErrors as f } from "../../errors/util/check-field-errors.mjs";
import { useTranslation as p } from "../../i18n.mjs";
import { isCancel as m } from "axios";
import { useCallback as h, useEffect as g, useState as _ } from "react";
import { jsx as v } from "react/jsx-runtime";
//#region src/fetch/use-base-fetch/index.tsx
var y = ({ httpClient: y, useRouter: b, toast: x }) => function({ method: S, showFieldsErrorToast: C, stopErrorPropagation: w, badRequestHandler: T, unauthorizedResponseHandler: E, unprocessableContentHandler: D, internalErrorHandler: O, afterFetch: k, accessDeniedHandler: A, onErrorBeforeErrorHandlers: j, onNotFound: M, mock: N }) {
	let P = b(), { t: F } = p(), [I, L] = _(0), [R, z] = _(!1);
	return g(() => z(!!I), [I]), {
		fetcher: h(async (...p) => {
			L((e) => e + 1);
			let h = typeof process < "u" && process.env.NODE_ENV === "development" || typeof process < "u" && process.env?.NEXT_PUBLIC_APP_ENV === "development" || typeof process < "u" && process.env?.APP_ENV === "development";
			return (N && h ? new Promise((e, t) => {
				let n = N.delay ?? 3e3;
				setTimeout(() => {
					N.error ? t(N.error) : e(N.data);
				}, n);
			}) : y[S](p[0], p[1], p[2]).then(async (e) => e && (k ? await k(e.data, e) : e.data))).catch(j).catch(async (p) => {
				if (typeof window < "u" && p instanceof c) M ? M(p) : process.env.NODE_ENV !== "development" && P.replace("/not-found");
				else if (typeof window < "u" && p instanceof t) A ? A(p) : P.push("/403");
				else if (typeof window < "u" && p instanceof u) E ? E(p) : window.location.assign(p.redirect);
				else if (p instanceof s) x.error(F("core.error.maintenance_error"));
				else if (typeof window < "u" && p instanceof a) O ? O(p) : x.error(F("core.error.internal_error_message"));
				else if (p instanceof n) C && p.errors && f(p.errors.fields) && x.error(F("global.errors.fields_toast_message")), T ? T(p) : p.message && x.error(/* @__PURE__ */ v("p", {
					className: "primary-link-container",
					dangerouslySetInnerHTML: { __html: p.message }
				}));
				else if (p instanceof r) x.error(F("core.error.conflict_error_message"));
				else if (p instanceof d) D ? D(p) : x.error(p.message || F("core.error.conflict_error_message"));
				else if (p instanceof o) x.error(p.message);
				else if (p instanceof l) x.error(F("core.error.payload_to_large_error_message"));
				else if (p instanceof i) x.error(/* @__PURE__ */ v("p", { dangerouslySetInnerHTML: { __html: p.message } }));
				else if (p instanceof e) throw p;
				else !(m(p) || p.code === "ECONNABORTED") && x.error(F("global.error"));
				if (!w) throw p;
			}).finally(() => L((e) => e - 1));
		}, [
			S,
			k,
			P,
			E,
			C,
			T,
			D,
			A,
			j
		]),
		isFetching: R
	};
};
//#endregion
export { y as getUseBaseFetch };
